export var ValueRomanizationMethod;
(function (ValueRomanizationMethod) {
    ValueRomanizationMethod["Pinyin"] = "pinyin";
    ValueRomanizationMethod["Romaji"] = "romaji";
    ValueRomanizationMethod["Wadegiles"] = "wadegiles";
})(ValueRomanizationMethod || (ValueRomanizationMethod = {}));
//# sourceMappingURL=ValueRomanizationMethod.js.map